const gtmTrackUserTraits = (...params) => {
  const etpAnalytics = window.etp?.analytics;

  if (etpAnalytics) {
    etpAnalytics?.gtm?.trackUserTraits(...params);
  }
};

export default gtmTrackUserTraits;
